<template>
  <section id="scroll-t-top" class="scroll-to-top bg-btn-hover rounded-circle mb-md-0 mb-5">
    <button class="w-100 pt-1" type="button" @click="scrollToTop0">
      <svg class="icon" width="20" height="20" fill="#000"><use href="@/assets/svgIcons/svgIcons.svg/#arrow-up"></use></svg>
    </button>
  </section>

</template>

<script>
export default {
  name: "ScrollToTop",
  methods:{
    scrollToTop0(){
      document.documentElement.scrollTo({
        top:0,
        behavior:"smooth"
      });

    }
  },
}
</script>

<style scoped>
/*+++ start scroll to top fixed +++*/

.scroll-to-top{
  width: 40px;
  height: 40px;
  position: fixed;
  left: 30px;
  bottom: -43px;
  transition: .3s;
  z-index: 444;
  border: 2px solid #000;
}
/*.scroll-to-top:hover{*/
/*  background-color: var(--color-theme2) !important;*/
/*}*/
.scroll-to-top button{
  background: unset;
  border: unset;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
/*+++ End scroll to top  fixed +++*/
@media screen and (max-width: 767px){
  .scroll-to-top{
    display: none;
  }
}
</style>